import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    "name",
    "email",
    "phone",
    "vintageYear",
    "organizationName",
    "wineColour",
    "wineStyle",
    "wineSweetness",
    // Add more targets as needed
  ];

  validate(event) {
    // Check if there are server-side errors first
    const serverErrors = document.querySelectorAll(
      ".field_with_errors, .error, .alert-danger, .alert-error"
    );
    if (serverErrors.length > 0) {
      console.log(
        "Server-side errors detected, allowing form submission for re-validation"
      );
      // Hide client-side errors when server-side errors exist
      const errorBox = document.getElementById("client-side-errors");
      if (errorBox) {
        errorBox.classList.add("hidden");
        errorBox.style.opacity = 0;
      }
      return; // Allow form to submit for server-side validation
    }

    let valid = true;
    let errors = [];
    // Remove previous error highlights
    this.nameTarget.classList.remove("border-red-500");
    this.emailTarget.classList.remove("border-red-500");
    this.phoneTarget.classList.remove("border-red-500");
    this.vintageYearTarget.classList.remove("border-red-500");
    this.organizationNameTarget.classList.remove("border-red-500");
    this.wineColourTarget.classList.remove("border-red-500");
    this.wineStyleTarget.classList.remove("border-red-500");
    this.wineSweetnessTarget.classList.remove("border-red-500");

    if (!this.nameTarget.value.trim()) {
      this.nameTarget.classList.add("border-red-500");
      errors.push("Wine Name can't be blank");
      valid = false;
    }
    if (!this.emailTarget.value.trim()) {
      this.emailTarget.classList.add("border-red-500");
      errors.push("Email can't be blank");
      valid = false;
    }
    if (!this.phoneTarget.value.trim()) {
      this.phoneTarget.classList.add("border-red-500");
      errors.push("Phone can't be blank");
      valid = false;
    }
    if (!this.vintageYearTarget.value.trim()) {
      this.vintageYearTarget.classList.add("border-red-500");
      errors.push("Vintage Year can't be blank");
      valid = false;
    }
    if (!this.organizationNameTarget.value.trim()) {
      this.organizationNameTarget.classList.add("border-red-500");
      errors.push("Organization Name can't be blank");
      valid = false;
    }
    if (!this.wineColourTarget.value.trim()) {
      this.wineColourTarget.classList.add("border-red-500");
      errors.push("Wine Color can't be blank");
      valid = false;
    }
    if (!this.wineStyleTarget.value.trim()) {
      this.wineStyleTarget.classList.add("border-red-500");
      errors.push("Wine Style can't be blank");
      valid = false;
    }
    if (!this.wineSweetnessTarget.value.trim()) {
      this.wineSweetnessTarget.classList.add("border-red-500");
      errors.push("Sweetness Level can't be blank");
      valid = false;
    }

    // Show/hide the error notification
    const errorBox = document.getElementById("client-side-errors");
    const errorList = document.getElementById("client-side-errors-list");
    if (!valid) {
      event.preventDefault();
      errorList.innerHTML = "";
      errors.forEach((msg) => {
        const li = document.createElement("li");
        li.textContent = msg;
        errorList.appendChild(li);
      });
      errorBox.classList.remove("hidden");
      errorBox.style.opacity = 0;
      errorBox.style.transition = "opacity 0.4s";
      setTimeout(() => {
        errorBox.style.opacity = 1;
      }, 10);
      // Scroll to the error box
      errorBox.scrollIntoView({ behavior: "smooth", block: "center" });
    } else {
      errorBox.classList.add("hidden");
      errorList.innerHTML = "";
      errorBox.style.opacity = 0;
    }
  }
}
